import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../helpers/constants";
import { getCookie, signout } from "../../helpers/cookies";

const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
        const token = getCookie("magiclock_admin_token");
        if (token) {
            headers.set("Authorization", `BEARER ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await customFetchBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 403) {
        signout(() => {
            window.location.href = "/login";
        });
    }

    return result;
};

const shopCustomersApis = createApi({
    reducerPath: "shopCustomersApis",
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 0,
    tagTypes: ["ShopCustomers", "ShopCustomerDetails"],
    endpoints: (build) => ({
        // Shop customers who registered in the app (separate from staff-created Customer Master)
        getShopCustomers: build.query({
            query: ({ pageNo, limit, keywords, status, sortField, sortBy }) => ({
                url: "/users/shop-customers",
                method: "GET",
                params: { pageNo, limit, keywords: keywords || "", status: status || "all", sortField, sortBy },
            }),
            transformResponse: (response) => response?.result || { count: 0, results: [] },
            providesTags: ["ShopCustomers"],
        }),
        getShopCustomerStats: build.query({
            query: () => ({ url: "/users/shop-customers/stats", method: "GET" }),
            transformResponse: (response) => response?.result,
            providesTags: ["ShopCustomers"],
        }),
        getShopCustomerDetails: build.query({
            query: (id) => ({ url: `/users/shop-customers/${id}`, method: "GET" }),
            transformResponse: (response) => response?.result,
            providesTags: ["ShopCustomerDetails"],
        }),
        updateShopCustomerStatus: build.mutation({
            query: ({ id, status, reason }) => ({
                url: `/users/shop-customers/${id}/status`,
                method: "PUT",
                body: { status, reason: reason || null },
            }),
            invalidatesTags: ["ShopCustomers", "ShopCustomerDetails"],
        }),
    }),
});

export const {
    useGetShopCustomersQuery,
    useGetShopCustomerStatsQuery,
    useGetShopCustomerDetailsQuery,
    useUpdateShopCustomerStatusMutation,
} = shopCustomersApis;

export default shopCustomersApis;
